import { Endpoints } from '@/network';

import { baseForPdf } from '../apiClients';

interface LogErrorOptions {
  level:
    | 'emergency'
    | 'critical'
    | 'error'
    | 'warning'
    | 'notice'
    | 'info'
    | 'debug';
  message: string;
  context?: any;
  additionalInfo?: any;
  useLogGroup?: boolean;
}

export const logFrontendError = async (options: LogErrorOptions) => {
  try {
    await baseForPdf.post(Endpoints.globalFrontendErrorLogs, options);
  } catch (err) {
    console.error('Failed to send frontend log:', err);
  }
};
